import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Search } from "@/shared/ui/search"
import { selectSocialMarketFoundationsSearchQuery, setSearchQuery } from "../../model"

export const SocialMarketFoundationsFilters = () => {
    const search = useAppSelector(selectSocialMarketFoundationsSearchQuery)
    const dispatch = useAppDispatch()

    return (
        <div>
            <Search
                value={search}
                onChange={(e) => dispatch(setSearchQuery(e))}
            />
        </div>
    )
}